import clsx from 'clsx';
import React from 'react';
import styles from './logo-norlys.module.scss';

interface Props extends React.SVGAttributes<SVGSVGElement> {
  onClick?: () => void;
}

export const LogoNorlys = (props: Props) => {
  const { className, width = 219, height = 42, color, onClick, ...rest } = props;

  return (
    <svg
      role={onClick ? 'button' : 'logo'}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      width={width}
      height={height}
      color={color}
      className={clsx(
        styles['logo-norlys'],
        onClick && styles['logo-norlys--clickable'],
        className
      )}
      viewBox="0 0 219 42"
      {...rest}
    >
      <path
        d="M28.712 26.067L7.677.84 0 .84 0 40.665 8.498 40.665 8.498 15.107 29.777 40.665 37.232 40.665 37.232.84 28.712.84zM177.243.84L167.568 17.93 157.916.84 148.286.84 163.264 26.596 163.264 40.665 171.873 40.665 171.873 26.596 186.85.84zM136.992.84L128.45.84 128.45 40.665 156.674 40.665 156.674 32.352 136.992 32.352zM116.268 24.413c3.64-2.425 5.814-6.439 5.814-10.761 0-6.593-5.037-12.018-11.516-12.746-.422-.044-1.154-.088-1.82-.088H88.4v39.825h8.543V26.618h8.454l8.01 14.025h9.608l-8.72-15.26c1.198-.44 1.841-.881 1.974-.97zm-7.233-6.064h-12.16V9.176h11.76c.622.022 1.287.066 1.975.286 1.753.64 2.996 2.36 2.996 4.344-.023 2.492-2.064 4.543-4.571 4.543z"
        transform="translate(-78.000000, -90.000000) translate(78.000000, 90.000000)"
      />

      <path
        d="M36.098 4.853C33.236 2.01 29.575.333 25.648.09c-1.576-.11-2.863-.088-2.863-.088v8.6s2.352.11 3.55.419c3.284.838 5.858 3.903 6.035 7.542.222 4.145.222 4.63 0 8.247-.221 3.683-2.795 6.77-6.057 7.586-1.376.353-3.528.463-3.528.463v8.556s1.775-.022 2.862-.088c3.95-.265 7.567-1.94 10.451-4.785 3.018-3 4.815-6.969 5.081-11.203.244-3.969.222-4.763 0-9.217-.222-4.234-2.041-8.248-5.08-11.269zM15.685.09C11.757.355 8.096 2.009 5.234 4.853 2.194 7.874.374 11.866.174 16.122c-.221 4.432-.243 5.248 0 9.217.267 4.212 2.064 8.204 5.082 11.203 2.862 2.844 6.48 4.52 10.45 4.785 1.088.066 2.863.088 2.863.088v-8.556s-2.152-.11-3.528-.463c-3.262-.816-5.835-3.925-6.057-7.586-.222-3.616-.2-4.102 0-8.247.177-3.66 2.751-6.704 6.035-7.542 1.198-.309 3.55-.419 3.55-.419v-8.6c-.022 0-1.309-.022-2.884.088z"
        transform="translate(-78.000000, -90.000000) translate(78.000000, 90.000000) translate(42.161021, 0.000188)"
      />

      <path
        d="M208.218 17.004c-1.975-.441-4.283-.772-6.346-1.08-1.442-.221-2.818-.42-3.55-.574-2.996-.662-2.974-2.558-2.974-3.396.023-2.095 2.441-3.352 4.815-3.528.4-.044.888-.066 1.465-.066.621 0 1.131.022 1.553.066 3.129.198 4.948 1.808 5.458 3.02.156.376.245.618.245.618h8.342c0-3.043-1.486-6.086-4.104-8.335-2.53-2.183-5.925-3.506-9.586-3.683-.954-.044-2.241-.066-3.284-.022-7.566.243-13.313 5.337-13.357 11.864-.045 5.777 3.616 10.188 9.563 11.51 1.02.221 2.463.442 4.15.685 1.93.286 4.104.617 5.768.97 4.105.904 4.083 3.11 4.083 3.837-.022 2.756-2.685 3.682-4.66 3.97-.665.131-1.708.264-3.128.242-1.487 0-2.53-.088-3.24-.199-1.708-.176-3.24-.882-4.349-1.984-.688-.662-1.043-1.346-1.309-2.338h-8.32c0 2.977 1.264 5.91 3.616 8.247 3.195 3.176 7.167 4.389 11.316 4.499 1.376.044 1.864.044 3.462.044 3.971-.022 7.255-.772 10.517-3.197 2.951-2.206 4.504-5.535 4.549-9.218.044-5.998-4.06-10.475-10.695-11.952z"
        transform="translate(-78.000000, -90.000000) translate(78.000000, 90.000000)"
      />
    </svg>
  );
};

export default React.memo(LogoNorlys);
